export default __webpack_public_path__ + "analytics-module-empty-heading.png";